import { useState, useEffect } from "react";
import { fetchJson } from "../utils/apiClient";
import { API_BASE } from "../constants/gameConstants";

export default function HallOfFame() {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchJson(`${API_BASE}/hall-of-fame`)
      .then(result => {
        if (result.ok) setData(result);
        else setError("Failed to load Hall of Fame");
      })
      .catch(() => setError("Error loading Hall of Fame"))
      .finally(() => setIsLoading(false));
  }, []);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-12">
        <div className="w-10 h-10 border-4 border-purple-400 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (error) {
    return <p className="text-red-300 text-center py-8">{error}</p>;
  }

  return (
    <div className="space-y-6">
      {/* Daily — first guess, 3+ times */}
      <div className="bg-white/10 backdrop-blur-md rounded-2xl p-4 md:p-8 shadow-2xl">
        <h2 className="text-2xl font-bold text-white mb-1">
          🎯 Daily Game — First Guess
        </h2>
        <p className="text-purple-300 text-sm mb-6">
          Solved the daily word on their first guess (2/6) at least 3 times
        </p>

        {data.daily.length === 0 ? (
          <p className="text-purple-200 text-center py-4">No entries yet</p>
        ) : (
          <div className="space-y-2">
            {data.daily.map((entry, i) => (
              <div
                key={entry.playerName}
                className={`rounded-lg px-4 py-3 flex justify-between items-center ${
                  i === 0
                    ? "bg-gradient-to-r from-yellow-500/30 to-yellow-600/30 border-2 border-yellow-400"
                    : "bg-white/10"
                }`}
              >
                <div className="flex items-center gap-3">
                  <span className={`text-2xl font-bold w-8 ${i === 0 ? "text-yellow-400" : "text-white"}`}>
                    #{i + 1}
                  </span>
                  <span className={`font-semibold ${i === 0 ? "text-yellow-100" : "text-white"}`}>
                    {entry.playerName}
                  </span>
                </div>
                <span className={`font-bold ${i === 0 ? "text-yellow-400" : "text-purple-200"}`}>
                  {entry.count}x
                </span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Golf — all holes par or better, 3+ times */}
      <div className="bg-white/10 backdrop-blur-md rounded-2xl p-4 md:p-8 shadow-2xl">
        <h2 className="text-2xl font-bold text-white mb-1">
          ⛳ Golf — All Holes Par or Better
        </h2>
        <p className="text-purple-300 text-sm mb-6">
          Completed a full round with every hole at par or under at least 3 times
        </p>

        {data.golf.length === 0 ? (
          <p className="text-purple-200 text-center py-4">No entries yet</p>
        ) : (
          <div className="space-y-2">
            {data.golf.map((entry, i) => (
              <div
                key={entry.playerName}
                className={`rounded-lg px-4 py-3 flex justify-between items-center ${
                  i === 0
                    ? "bg-gradient-to-r from-yellow-500/30 to-yellow-600/30 border-2 border-yellow-400"
                    : "bg-white/10"
                }`}
              >
                <div className="flex items-center gap-3">
                  <span className={`text-2xl font-bold w-8 ${i === 0 ? "text-yellow-400" : "text-white"}`}>
                    #{i + 1}
                  </span>
                  <span className={`font-semibold ${i === 0 ? "text-yellow-100" : "text-white"}`}>
                    {entry.playerName}
                  </span>
                </div>
                <span className={`font-bold ${i === 0 ? "text-yellow-400" : "text-purple-200"}`}>
                  {entry.count}x
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
